import { css } from '@emotion/react';
import { Types } from '@scorenco/core';

import { OptimizedImage } from '../../primitives';
import { forceAbsoluteStrapiUrl } from '../forceAbsoluteStrapiUrl';

type StrapiImageProps = {
  image?: Types.UploadFile;
};

export const StrapiImage = ({ image, ...rest }: StrapiImageProps) => {
  const url = forceAbsoluteStrapiUrl(image?.url);

  if (!url) {
    return null;
  }

  return (
    <OptimizedImage
      css={css`
        display: block;
        width: 100%;
        height: auto;
      `}
      src={url}
      width={image!.width as number}
      height={image!.height as number}
      alt={image!.alternativeText}
      {...rest}
    />
  );
};
